import styled from "styled-components"

const ArianeSection = styled.nav`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  & a:hover {
    color: white;
  }
`

export { ArianeSection }
